<template>
    <contentCard :loading="loading">
        <template slot="cardContent">
			<div>
                <v-row justify="center" >
                    <v-col class="text-center col-md-8">
                        <div class="font-weight-bold body-1">
                            Editar Requisición
                        </div>
                    </v-col>
                </v-row>
                <v-row justify="center">
                    <v-col cols="12" md="8">
                        <v-form ref="form" @submit.prevent="save">
                            <requisition-form ref="RequisitionForm" :values="form" @save="save" :serverErrors="serverErrors" :edit="true"></requisition-form>
                        </v-form>
                    </v-col>
                    
                </v-row>
            </div>

            <v-row justify="center" align="end">
				<v-col cols="12" md="8" class="">
                    <v-row justify="end" class="px-3 py-3">
                        <secondary-button data-cy="cancel-btn" :props="cancelBtnData" class="mr-0 mr-sm-2 mb-3 mb-sm-0"></secondary-button>
                        <primary-button data-cy="accept-btn" :props="saveBtnData" class=""></primary-button>  
                    </v-row>
				</v-col>
			</v-row>
        </template>
    </contentCard>
</template>

<script>
import Object2Form from '../../../helpers/Object2Form';
import Utils from '../../../helpers/Utils';
import RequisitionForm from "./Form.vue";
export default {
    components: {
        'requisition-form': RequisitionForm,
    },
	data(){
		return {
            loading: false,
            serverErrors: {},
            id: this.$route.params.id,
            form: {
                date: "",
                priority: 0,
                client_id: "",
                client_product_id: "",
                warehouse_id: "",
                observations: "",
                supplies: [
                   
                ],

                //local
                comments:[],

                    
            },
            cancelBtnData: {
                text: "Cancelar",
                icon: "mdi-close",
                to: "Requisitions",
                block:false,
                click: () => {}
            },
            saveBtnData: {
                text: "Guardar cambios",
                icon: "mdi-content-save-outline",	
                click: this.save,
                block:false,
                loading: false,
            },
            snackbarProps: {
                visible: false,
				color: 'success',
				timeout: 3000,
				text: '',
            },
		}
    },
    mounted(){
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
        this.index();
    },
	methods: {

       
        onResize () {
            
            if(window.innerWidth < 600){
                this.saveBtnData.block = true;
                this.cancelBtnData.block = true;
            }
            else{
                this.saveBtnData.block = false;
                this.cancelBtnData.block = false;
            }
        },
		validate () {
            if(!Utils.objectIsEmpty(this.serverErrors))
                return false;
			return this.$refs.form.validate();
            // return true;
		},
        index(){
			//this.$store.state.overlay = true
			this.loading = true;
            this.$store.state.loading = true;
			this.$api.requisition.get(this.id)
			.then((response) => {
                console.log(response);
                

                this.form.date = response.data.data?.date;
                this.form.priority = response.data.data?.priority;
                this.form.client_id = response.data.data?.client_id;
                this.form.client_product_id = response.data.data?.client_product_id;
                this.form.warehouse_id = response.data.data?.warehouse_id;
                this.form.observations = response.data.data?.observations;

                //supplies 
                this.form.supplies = response.data.supplies.map((x) => {
                    console.log(x, "antes")
                    if(x.comments == null) {
                        x.comments = [];
                    }
                    if(x.visual_support_url == null) {
                        x.visual_support_url = [];
                    }
                    console.log(x, "desp")
                    return x;
                });

                console.log(this.form, "form final");

                // // //comments - local ?
                // this.form.supplies[0].comments.push({
                //     comments: "c1",
                //     date:"2024-12-13 19:44:04",
                //     position: "left",
                //     user:  "Alejandro Toro"
                // });
                //  this.form.supplies[0].comments.push({
                //     comments: "c1kajsdh laksdjha sdkhk",
                //     date:"2024-12-13 19:44:04",
                //     position: "left",
                //     user:  "Alejandro Toro"
                // });
                //  this.form.supplies[0].comments.push({
                //     comments: "csdkjfhskdfj hksd jfhdkisjdhf ksdijfhksdjfhs dfkjhsdk fjhsdkfjhskdfj1",
                //     date:"2024-12-13 19:44:04",
                //     position: "left",
                //     user:  "Alejandro Toro"
                // });
                //  this.form.supplies[0].comments.push({
                //     comments: "c1sdfsdfkjs dfkjdsfhskdj fhlskdjfhlask jfhlaskjd fhlaskjdfhlasdkjfh alsdkfjh adklsjdlsjdhlkjshdf",
                //     date:"2024-12-13 19:44:04",
                //     position: "right",
                //     user:  "Alejandro Toro"
                // });
                // // this.form.comments = response.data.comments;

                
			})
			.catch(error => {
				console.log(error);
			})
			.finally(() => {
				this.loading = false;
                this.$store.state.loading = false;
			})
		},
        save(){
            
            // console.log(this.form);
            
            if(this.validate()){
                
                let form = this.prepareRequest(this.form);
                console.log(form);
                this.saveBtnData.loading = true;
                this.$store.state.loading = true;
                this.$api.requisition.update(this.id, form)
                    .then(() => {
                        //console.log(response)

                        this.$store.dispatch('snackbarSuccess', `Se ha actualizado correctamente`);
                        this.$router.push({name: 'Requisitions'});
                    })
                    .catch((error) => {
                        var errors = []
                        switch(error.response.status){
                            case 422: 
                                
                                if(("errors" in error.response.data)){
                                    if(error.response.data.errors instanceof Object){
                                        Object.keys(error.response.data.errors).forEach((x) => {
                                            
                                               
                                            console.log(x);
                                            this.serverErrors = error.response.data.errors;
                                            error.response.data.errors[x].forEach((y) => {
                                                this.serverErrors[x] = Utils.deleteWord(x,y);
                                                errors.push(Utils.deleteWord(x,y))
                                            })
                                        });
                                    }else{
                                        errors.push(error.response.data.errors)
                                    }
                                    
                                    this.$store.dispatch('snackbarError', errors.join('.<br>'));
                                }
                               
                            break;
                           
                        }
                        console.log(this.serverErrors)
                       
                    })
                    .finally(() => {
                        this.saveBtnData.loading = false;
                        this.$store.state.loading = false;
                    })
                ;
            }else{
                
                this.$store.dispatch('snackbarError', `Formulario incompleto`);
            }
            // eslint-disable-next-line no-console
        },
        prepareRequest(request)
        {
           
            let data = JSON.parse(JSON.stringify(request));
           
            if(data.priority)
                data.priority = 1;
            
            for (let i = 0; i < data.supplies.length; i++) {
                delete data.supplies[i].name;
                delete data.supplies[i].actions;
                delete data.supplies[i].parameters;
                delete data.supplies[i].menu;
                delete data.supplies[i].unit;
                delete data.supplies[i].part;
                data.supplies[i].visual_support = []
                if(request.supplies[i].visual_support.length >=1)
                    data.supplies[i].visual_support = request.supplies[i].visual_support;
                else
                    data.supplies[i].visual_support = null;
                    // delete data.supplies[i].visual_support;
                
                if(data.supplies[i].visual_support == null || data.supplies[i].visual_support.length == 0){
                    data.supplies[i].visual_support = null
                }

                if(Array.isArray(data.supplies[i].comments)){
                    data.supplies[i].comments = ""
                }
                // data.supplies[i].comments =  data.supplies[i].comments;

                delete data.supplies[i].localMessages;
                delete data.supplies[i].imagesUrls;
                delete data.supplies[i].visual_supportBackup;
                
            }
            return Object2Form.objectToFormData(data, "", []);
        }
        
    },
}
</script>

<style>

</style>